document.addEventListener("DOMContentLoaded", function () {
  const faders = document.querySelectorAll('.fade-in-section');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Optional: Unobserve once visible
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });

  faders.forEach(fader => {
    observer.observe(fader);
  });
});
